<template>
  <div class="animation-container">
    <transition appear :name="`slide-${direction}`">
      <div
        :style="{ transitionDelay: `${delay}ms` }"
        style="position: relative;"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    delay: {
      type: Number,
      default: 0
    },

    direction: {
      type: String,
      default: "up"
    }
  }
};
</script>

<style lang="scss" scoped>
// =============
//      up
// =============
.slide-up-enter {
  opacity: 0;
  transform: translateY(100%);
}

.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0%);
  transition: opacity 500ms ease, transform 500ms ease;
}

// =============
//     left
// =============

.slide-left-enter {
  position: relative;
  left: 100%;
}

.slide-left-enter-to {
  left: 0%;
  transition: left 400ms ease;
}

// =============
//     right
// =============

.slide-right-enter {
  transform: translateX(-100%);
}

.slide-right-enter-to {
  transform: translateX(0);
  transition: transform 500ms ease;
}
</style>
